import i18n from "@/libs/i18n";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import { ref, watch, computed } from '@vue/composition-api'

export default function useTaxList() {
    const toast = useToast()
    const refTaxListTable = ref(null)
    const perPage = ref(10)
    const totalTax = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('value')
    const isSortDirDesc = ref(true)

    const tableColumns = [
        { key:'name', label: i18n.t('Name'), sortable: true},
        { key:'value', label: i18n.t('Value'), sortable: true},
        { key:'equivalence', label: i18n.t('Surcharge equivalence'), sortable: true},
        { key:'actions', label: i18n.t('Actions') }
    ]

    const dataMeta = computed(() => {
        const localItemsCount = refTaxListTable.value ? refTaxListTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalTax.value,
        }
    });

    const refetchData = function() {
        refTaxListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchTax = function(ctx, callback) {
        store.dispatch('taxes/fetchTaxes', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { taxes, total } = response.data
            callback(taxes)
            totalTax.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching taxes list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        fetchTax,
        tableColumns,
        perPage,
        currentPage,
        totalTax,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTaxListTable,
        refetchData,
    }
}